import IndexController from '../index_controller'

export default class extends IndexController {
  paginate (event) {
    this.fetchResults({}, event.detail.page)
  }
}
